import type { FeatureStyleNode } from '../feature-style.model';
import type { HandleBehavior } from '../../../graphpad.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Handle feature parameters */
export interface HandleParams {
  /** Reference to parent function element */
  of: string;
  /** The behavior when dragging this handle */
  behavior: HandleBehavior;
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** No defaults - both `of` and `behavior` must be provided */
export const HANDLE_DEFAULT_PARAMS: Omit<HandleParams, 'of' | 'behavior'> = {};

/**
 * Default theme for handle feature.
 * - Fill color matches the parent curve color (inherited from display config)
 * - White stroke outline for visibility (handled in creator since 'neutral-0' is not a ThemeColorName)
 * - Size 8 for easy interaction
 * - Grab handle enabled by default for touch-friendly dragging
 */
export const HANDLE_DEFAULTS: FeatureStyleNode = {
  point: {
    size: 5,
    strokeWidth: 0,
    showGrabHandle: true,
  },
};
